// services/razorpayApi.js
import { postMethod } from '../utils/api'

/* Create a new order (not used for retry, but reusable) */
export const createRazorpayOrder = ({
  packageId,
  submissionId = null,
  upsellId = null,
  advertiserId
}) => {
  const data = new FormData()
  data.append('submission_type', 3)
  data.append('package_id', packageId)
  if (submissionId) data.append('profile_id', submissionId)
  data.append('notes', JSON.stringify({ advertiser_id: advertiserId }))
  data.append(
    'meta',
    JSON.stringify({
      package_id: packageId,
      ...(upsellId && { upselling_option_id: upsellId })
    })
  )

  return postMethod({ url: `/payments/razorpay/order/`, data })
}

/* Validate order after success */
export const validateRazorpayOrder = ({ paymentId, orderRowId, signature }) => {
  const data = new FormData()
  data.append('razorpay_payment_id', paymentId)
  data.append('user_role', 9)
  data.append('order_row_id', orderRowId)
  data.append('razorpay_signature', signature)

  return postMethod({ url: `/payments/razorpay/validate/`, data })
}
